import { useMemo } from 'react';
import { Invoice } from 'olo-service';
import { GiftCardItem, GiftCard } from 'olo-service/models';
import { formatSummary, formatRequest } from 'olo-service/Order';
import { DetailedCartItem } from 'hooks/context/cart';
import { useColoResource } from './useColoResource';
import { isSlug } from './isSlug';
import { useCustomer } from 'hooks/context/customer/customer';
import { useDelivery } from 'hooks/context/Delivery';

export function usePostCheckoutResource(merchantId: string | undefined, cartItems: DetailedCartItem[], giftCards: GiftCardItem[], subtotal: number, type?: string, perkUuid?: string, appliedGiftCards : GiftCard[] = [], tipValue? : number ) {
  const { sessionToken, customer } = useCustomer();
  const { deliveryAddress: address } = useDelivery();

  const payload = {
    ...formatRequest({ cartItems, giftCards,tipValue }),
    type,
    perkUuid,
    globalCustomerUuid: customer?.globalCustomerUuid,
    address,
    cwoOrder: true,
    ...(!!appliedGiftCards?.length && { giftSources: appliedGiftCards }),
  };

  const [isInvoiceSummaryLoading, invoice, error] = useColoResource<Invoice>(
    () => (merchantId && subtotal > 0) && {
        method: 'POST',
        url: `${merchantId}/checkout`,
        headers: sessionToken
          ? {
              'X-Clover-Customer-Auth': sessionToken,
            }
          : null,
        params: { slug: isSlug(merchantId) },
        data: payload,
      },
    [merchantId, subtotal, cartItems, type, sessionToken, perkUuid, appliedGiftCards,tipValue]
  );

  const invoiceSummary = useMemo(() => (subtotal <= 0 || !invoice) ? undefined : formatSummary(invoice), [invoice, subtotal]);

  return { isInvoiceSummaryLoading, invoiceSummary, error };
}

